import _ from 'lodash';

import {
  RecipePreparationFiltersEnum as Fields,
  RecPrepRecipeFieldEnum as RecPrepFields,
} from 'Common/FieldEnum';
import { MenuMealTypesEnum } from 'Common/Constants/Enumeration/MealTypesEnum';

export const TABS = {
  RECIPE_GROUP: 0,
  CYCLE_MENU: 1,
  CALENDAR_MENU: 2,
};

// map tab to filters
export const TAB_FILTERS = {
  [TABS.RECIPE_GROUP]: [Fields.Status, Fields.GroupId],
  [TABS.CYCLE_MENU]: [Fields.Status, Fields.CycleMenuId],
  [TABS.CALENDAR_MENU]: [
    Fields.Status,
    Fields.SiteId,
    Fields.MealTypeId,
    Fields.Date,
  ],
};

export const getFiltersForTab = (tab, filters) =>
  _.pick(filters, TAB_FILTERS[tab]);

export const MealTypeOptions = [
  {
    value: MenuMealTypesEnum.Breakfast,
    text: 'Breakfast',
  },
  {
    value: MenuMealTypesEnum.Lunch,
    text: 'Lunch',
  },
];

export const StatusOptions = [
  {
    label: 'All',
    value: 0,
  },
  {
    label: 'Active',
    value: 1,
  },
  {
    label: 'Inactive',
    value: 2,
  },
];

export const OrderByOptions = [
  { label: 'Name', value: 'Name' },
  {
    label: 'Id',
    value: 'Id',
  },
];

/**
 * Maps the form values for Recipe Preparation table to API parameters
 * @param {Array<Object>} values
 * @returns {Array<Object>}
 */
export const mapFormToParam = (values, orderBy) => {
  const recipes = values
    .filter(
      v =>
        v[RecPrepFields.Selected] &&
        Number(v[RecPrepFields.NumberOfPortion]) > 0
    )
    .map(v => {
      return {
        RecipeId: v[RecPrepFields.RecipeId],
        NumberOfPortion: Number(v[RecPrepFields.NumberOfPortion]),
      };
    });

  return {
    Recipes: recipes,
    OrderBy: {
      SortName: orderBy,
      SortDirection: 'asc',
    },
  };
};



// WEBPACK FOOTER //
// ./src/pages/recipepreparation/helpers/index.js